import React, { useState } from 'react';
import { useMutation } from "react-query";
import { Button } from '@mui/material';
import apiClient from "../../request/http-common";
import Card from '@mui/material/Card';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setWithdrawals } from '../../request/Analysis/hitorySlice';
import WithdrawalFormFields from '../Withdrawal/WithdrawalFormFields';
import useWithdrawalCoinOptions from '../../hooks/useWithdrawalCoinOptions';

const SendCoin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { estimateCoinDeduction, formatUsd, formatCryptoAmount, getCoinUnits, getCoinUsd } = useWithdrawalCoinOptions();

    const [error, setErros] = useState('');
    const [amount, setAmount] = useState('');
    const [coinName, setCoinName] = useState('');
    const [address, setAddress] = useState('');
    const [destinationTag, setDestinationTag] = useState('');

    const usdAmount = parseFloat(amount) || 0;
    const { coinAmount: coinToDeduct } = estimateCoinDeduction(coinName, usdAmount);
    const availableUnits = coinName ? getCoinUnits(coinName) : 0;
    const availableUsd = coinName ? getCoinUsd(coinName) : 0;

    const { isLoading: isWithdrawing, mutate: postWithdrawal } = useMutation(
        async () => {
          const payload = {
            amount: usdAmount,
            coin_name: coinName,
            address: address,
          };
          if (coinName === 'XRP' && destinationTag.trim()) {
            payload.destination_tag = destinationTag.trim();
          }
          return await apiClient.post(`/api/withdraw`, payload);
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                window.dispatchEvent(new Event('newMessage'));
                dispatch(setWithdrawals(res.data.withdrawals));
                setTimeout(() => navigate('/account-wallet'), 2000);
              }
          },
          onError: (err) => {
                if (err.response?.data?.errors) {
                    setErros(err.response.data.errors);
                } else {
                    const errorMessage = err.response?.data?.message || err.message || 'Withdrawal failed';
                    localStorage.setItem('notification', JSON.stringify({message : errorMessage, type: 'error' }));
                    window.dispatchEvent(new Event('newMessage'));
                }
          },
        }
      );

    const handleWithdraw = () => {
      if (!coinName) {
        window.dispatchEvent(new Event('newMessage'));
        localStorage.setItem('notification', JSON.stringify({ message: 'Select a coin to withdraw from', type: 'error' }));
        return;
      }
      if (usdAmount < 1) {
        localStorage.setItem('notification', JSON.stringify({ message: 'Enter a valid USD amount', type: 'error' }));
        window.dispatchEvent(new Event('newMessage'));
        return;
      }
      if (coinToDeduct > availableUnits) {
        localStorage.setItem('notification', JSON.stringify({
          message: `Insufficient ${coinName}. Available: ${formatCryptoAmount(availableUnits)} ${coinName} (${formatUsd(availableUsd)})`,
          type: 'error',
        }));
        window.dispatchEvent(new Event('newMessage'));
        return;
      }
      if (!address?.trim()) {
        localStorage.setItem('notification', JSON.stringify({ message: 'Enter your wallet address', type: 'error' }));
        window.dispatchEvent(new Event('newMessage'));
        return;
      }
      postWithdrawal();
    };

  return (
    <div style={{ marginTop: '70px' }}>
      <Card className='box' sx={{ borderRadius: '9px', height: '100%', margin: 2}}>
    <Typography my={3} px={4} sx={{textAlign: 'center'}} variant="body2" color="white">
    Fill the form below to withdraw funds
    </Typography>

    <CardContent>
      <WithdrawalFormFields
        amount={amount}
        setAmount={setAmount}
        coinName={coinName}
        setCoinName={setCoinName}
        address={address}
        setAddress={setAddress}
        destinationTag={destinationTag}
        setDestinationTag={setDestinationTag}
        error={error}
      />
    </CardContent>

    <CardActions>
    <Button
      onClick={handleWithdraw}
      fullWidth
      size="large"
      color="primary"
      variant="contained"
      disabled={isWithdrawing}
    >
      {isWithdrawing ? 'Processing...' : 'Withdraw'}
    </Button>
    </CardActions>

  </Card>
    </div>
  )
}

export default SendCoin
